var MapMarkerIcon = /** @class */ (function () {
    function MapMarkerIcon(iconUrl, iconSize, iconAnchor, popupAnchor) {
        this.iconUrl = iconUrl;
        this.iconSize = iconSize;
        this.iconAnchor = iconAnchor !== null && iconAnchor !== void 0 ? iconAnchor : [iconSize[0] / 2, iconSize[1]];
        this.popupAnchor = popupAnchor !== null && popupAnchor !== void 0 ? popupAnchor : [0, -iconSize[1]];
    }
    MapMarkerIcon.prototype.fixIconUrl = function () {
        var mmd = document.MapMetaData;
        var basePath = (mmd) ? mmd.baseUrl : '/wp-content/plugins/Agilis-Notifications/';
        this.iconUrl = this.iconUrl.replace('%basePath%', basePath);
        return this;
    };
    return MapMarkerIcon;
}());
export default MapMarkerIcon;
